import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooFinds } from '@/utils/articleContent';

export default function SugargooFindsPage() {
  return <ArticleLayout article={sugargooFinds} />;
}